import { render, staticRenderFns } from "./SaleEcharts.vue?vue&type=template&id=0b5c713a&scoped=true&"
import script from "./SaleEcharts.vue?vue&type=script&lang=js&"
export * from "./SaleEcharts.vue?vue&type=script&lang=js&"
import style0 from "./SaleEcharts.vue?vue&type=style&index=0&id=0b5c713a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c713a",
  null
  
)

export default component.exports